/**
 * Baptist Cancer Center Locations Search
 *
 * Replaces the previous Angular LocationSearchController while preserving the
 * existing asynchronous search experience.
 *
 * Initial results are rendered server-side by Search.cshtml. Subsequent
 * filtering, sorting, paging, and location changes request the shared Razor
 * partial from BccLocationsController.Search and replace only the results area.
 */
(function ($) {
    'use strict';

    var SEARCH_ENDPOINT = '/api/sitecore/BccLocations/Search';

    /**
     * Initializes every locations search component on the page.
     */
    $(document).ready(function () {
        $('[data-location-search-component]').each(function () {
            initializeLocationSearch($(this));
        });
    });

    /**
     * Initializes one locations search component.
     */
    function initializeLocationSearch($component) {
        var $filterWrapper = $component.find('[data-location-filter-wrapper]');
        var $addressInput = $component.find('[data-location-address]');
        var $loading = $component.find('[data-location-loading]');

        /*
         * Keep the current search state in the page URL.
         *
         * This preserves bookmark/back-forward behavior while allowing the
         * results themselves to update asynchronously.
         */
        function getSearchParams() {
            return new URLSearchParams(window.location.search);
        }

        /**
         * Writes the supplied search parameters to the browser URL without
         * causing a full page reload.
         */
        function updateBrowserUrl(searchParams) {
            var queryString = searchParams.toString();

            var newUrl =
                window.location.pathname +
                (queryString ? '?' + queryString : '') +
                window.location.hash;

            // Update the browser URL without reloading the page.
            window.history.pushState(
                { path: newUrl },
                '',
                newUrl
            );

            // Keep the Secondary Hero search form synchronized with the
            // current asynchronously updated locations search state.
            $('form.bcc-search-form').each(function () {
                var $form = $(this);

                // Remove existing hidden query-string fields.
                $form.find('input[type="hidden"][data-location-search-param]').remove();

                // Add the current query-string values back to the form.
                searchParams.forEach(function (value, key) {

                    // The hero's visible search input already owns "q".
                    if (key === 'q') {
                        return;
                    }

                    $('<input>', {
                        type: 'hidden',
                        name: key,
                        value: value,
                        'data-location-search-param': ''
                    }).appendTo($form);
                });
            });
        }

        /**
         * Adds, updates, or removes a query-string parameter.
         */
        function setSearchParam(searchParams, key, value) {
            if (value === null ||
                value === undefined ||
                value === '') {
                searchParams.delete(key);
            } else {
                searchParams.set(key, value);
            }
        }

        /**
         * Returns all currently checked values for a filter.
         */
        function getCheckedValues(selector) {
            return $component
                .find(selector + ':checked')
                .map(function () {
                    return $(this).val();
                })
                .get();
        }

        /**
         * Synchronizes the current service and cancer checkbox selections to
         * the query string.
         */
        function syncFilterParams(searchParams) {
            var services =
                getCheckedValues('[data-location-service]');

            var cancers =
                getCheckedValues('[data-location-cancer]');

            setSearchParam(
                searchParams,
                's',
                services.length > 0
                    ? services.join(';')
                    : null
            );

            setSearchParam(
                searchParams,
                'c',
                cancers.length > 0
                    ? cancers.join(';')
                    : null
            );
        }

        /**
         * Shows or hides the loading state used during asynchronous requests.
         */
        function setLoading(isLoading) {
            if (!$loading.length) {
                return;
            }

            if (isLoading) {
                $loading.show();
            } else {
                $loading.hide();
            }
        }

        /**
         * Requests the server-rendered results partial and replaces the current
         * results container.
         *
         * resetPage should be true whenever criteria other than the page itself
         * change so the search returns to page 1.
         */
        function getResults(resetPage) {
            var searchParams = getSearchParams();

            syncFilterParams(searchParams);

            if (resetPage) {
                searchParams.set('p', '1');
            }

            /*
             * Preserve the original locations-search behavior where distance
             * defaults to zero when it is not otherwise present.
             */
            if (!searchParams.has('d')) {
                searchParams.set('d', '0');
            }

            updateBrowserUrl(searchParams);
            setLoading(true);

            $.ajax({
                url: SEARCH_ENDPOINT,
                method: 'GET',
                data: searchParams.toString(),
                cache: false
            })
                .done(function (html) {
                    var $currentResults =
                        $component.find(
                            '[data-location-results-container]'
                        );

                    /*
                     * The Razor partial includes its own
                     * data-location-results-container wrapper, so replace the
                     * entire current wrapper rather than only its inner HTML.
                     */
                    $currentResults.replaceWith(html);
                })
                .fail(function () {
                    alert('A search error occurred.');
                })
                .always(function () {
                    setLoading(false);
                });
        }

        /**
         * Converts an address or coordinate lookup into the latitude/longitude
         * state expected by LocationsCriteria.
         */
        function updateLocation(result) {
            if (!result) {
                return;
            }

            var searchParams = getSearchParams();

            if ($addressInput.length && result.address) {
                $addressInput.val(result.address);
            }

            searchParams.set('lt', result.lat);
            searchParams.set('ln', result.lng);
            searchParams.set('so', 'DT');
            searchParams.set('p', '1');

            updateBrowserUrl(searchParams);
            getResults(false);
        }

        /**
         * Uses the Google Maps geocoder to resolve either an address or a
         * browser-provided coordinate.
         */
        function geoCode(query, callback) {
            if (!window.google ||
                !google.maps ||
                !google.maps.Geocoder) {
                return;
            }

            var geocoder = new google.maps.Geocoder();

            geocoder.geocode(
                query,
                function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK &&
                        results &&
                        results.length > 0) {
                        var data = results[0];

                        callback({
                            address: data.formatted_address,
                            lat: data.geometry.location.lat(),
                            lng: data.geometry.location.lng()
                        });

                        return;
                    }

                    callback(null);
                }
            );
        }

        /**
         * Gets the user's browser geolocation.
         */
        function getCurrentLocation(callback) {
            if (!navigator.geolocation) {
                return;
            }

            navigator.geolocation.getCurrentPosition(
                function (position) {
                    if (!position ||
                        !position.coords) {
                        return;
                    }

                    callback({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    });
                }
            );
        }

        /*
         * Service filters.
         *
         * These checkboxes live outside the asynchronously replaced results
         * partial, so their handlers can be bound directly.
         */
        $component
            .find('[data-location-service]')
            .on('change', function () {
                getResults(true);
            });

        /*
         * Cancer filters.
         */
        $component
            .find('[data-location-cancer]')
            .on('change', function () {
                getResults(true);
            });

        /*
         * Clear all selected service filters.
         */
        $component
            .find('[data-location-clear-services]')
            .on('click', function (e) {
                e.preventDefault();

                $component
                    .find('[data-location-service]')
                    .prop('checked', false);

                getResults(true);
            });

        /*
         * Clear all selected cancer filters.
         */
        $component
            .find('[data-location-clear-cancers]')
            .on('click', function (e) {
                e.preventDefault();

                $component
                    .find('[data-location-cancer]')
                    .prop('checked', false);

                getResults(true);
            });

        /*
         * Clear the current location and return to alphabetical sorting.
         */
        $component
            .find('[data-location-clear-location]')
            .on('click', function (e) {
                e.preventDefault();

                var searchParams = getSearchParams();

                if ($addressInput.length) {
                    $addressInput.val('');
                }

                searchParams.delete('lt');
                searchParams.delete('ln');
                searchParams.set('so', 'AZ');
                searchParams.set('p', '1');

                updateBrowserUrl(searchParams);
                getResults(false);
            });

        /*
         * Clear all service, cancer, and location selections.
         *
         * This handler is delegated because a Clear All link also exists inside
         * the asynchronously replaced results partial.
         */
        $component.on(
            'click',
            '[data-location-clear-all]',
            function (e) {
                e.preventDefault();

                var searchParams = getSearchParams();

                $component
                    .find('[data-location-service], [data-location-cancer]')
                    .prop('checked', false);

                if ($addressInput.length) {
                    $addressInput.val('');
                }

                searchParams.delete('s');
                searchParams.delete('c');
                searchParams.delete('lt');
                searchParams.delete('ln');
                searchParams.set('so', 'AZ');
                searchParams.set('p', '1');

                updateBrowserUrl(searchParams);
                getResults(false);
            }
        );

        /*
         * Remove one selected service from the result-summary chips.
         *
         * Delegation is required because the chips are replaced after every
         * asynchronous response.
         */
        $component.on(
            'click',
            '[data-location-remove-service]',
            function (e) {
                e.preventDefault();

                var value =
                    $(this).attr(
                        'data-location-remove-service'
                    );

                $component
                    .find('[data-location-service]')
                    .filter(function () {
                        return $(this).val() === value;
                    })
                    .prop('checked', false);

                getResults(true);
            }
        );

        /*
         * Remove one selected cancer from the result-summary chips.
         */
        $component.on(
            'click',
            '[data-location-remove-cancer]',
            function (e) {
                e.preventDefault();

                var value =
                    $(this).attr(
                        'data-location-remove-cancer'
                    );

                $component
                    .find('[data-location-cancer]')
                    .filter(function () {
                        return $(this).val() === value;
                    })
                    .prop('checked', false);

                getResults(true);
            }
        );

        /*
         * Sort results.
         *
         * Sort controls live inside the asynchronously replaced partial, so use
         * delegated event handling.
         */
        $component.on(
            'click',
            '[data-location-sort]',
            function (e) {
                e.preventDefault();

                var sort =
                    $(this).attr('data-location-sort');

                var searchParams = getSearchParams();

                /*
                 * Distance sorting is only valid when coordinates are present.
                 */
                if (sort === 'DT' &&
                    (!searchParams.get('lt') ||
                        !searchParams.get('ln'))) {
                    return;
                }

                searchParams.set('so', sort);
                searchParams.set('p', '1');

                updateBrowserUrl(searchParams);
                getResults(false);
            }
        );

        /*
         * Pagination.
         *
         * Pagination lives inside the asynchronously replaced partial, so this
         * handler is delegated from the component.
         */
        $component.on(
            'click',
            '[data-location-page]',
            function (e) {
                e.preventDefault();

                var page =
                    parseInt(
                        $(this).attr('data-location-page'),
                        10
                    );

                if (!page || page < 1) {
                    return;
                }

                var searchParams = getSearchParams();

                searchParams.set('p', page);

                updateBrowserUrl(searchParams);

                var $totalSort =
                    $component.find('.total-sort');

                if ($totalSort.length) {
                    $(
                        [
                            document.documentElement,
                            document.body
                        ]
                    ).animate(
                        {
                            scrollTop:
                                $totalSort.offset().top
                        },
                        250
                    );
                }

                getResults(false);
            }
        );

        /*
         * Address search button.
         */
        $component
            .find('[data-location-address-search]')
            .on('click', function () {
                var address =
                    $addressInput.val().trim();

                if (!address) {
                    return;
                }

                geoCode(
                    { address: address },
                    function (result) {
                        updateLocation(result);
                    }
                );
            });

        /*
         * Allow Enter in the location field to perform the same address search
         * as clicking the Search button.
         */
        $addressInput.on('keydown', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();

                $component
                    .find('[data-location-address-search]')
                    .trigger('click');
            }
        });

        /*
         * Use the browser's current location and reverse-geocode it so the input
         * can display the formatted address.
         */
        $component
            .find('[data-location-current-location]')
            .on('click', function (e) {
                e.preventDefault();

                getCurrentLocation(
                    function (coords) {
                        geoCode(
                            { location: coords },
                            function (result) {
                                updateLocation(result);
                            }
                        );
                    }
                );
            });

        /*
         * Mobile filter panel controls.
         */
        $component
            .find('[data-location-mobile-filter-open]')
            .on('click', function (e) {
                e.preventDefault();

                $filterWrapper.addClass('show');
            });

        $component
            .find('[data-location-mobile-filter-close]')
            .on('click', function (e) {
                e.preventDefault();

                $filterWrapper.removeClass('show');
            });

        /*
         * Prevent Bootstrap dropdowns from closing when filter checkboxes are
         * clicked.
         */
        $component
            .find('.location-services .dropdown-menu')
            .on('click', function (e) {
                e.stopPropagation();
            });

        $component
            .find('.location-cancers .dropdown-menu')
            .on('click', function (e) {
                e.stopPropagation();
            });

        /*
         * Keep asynchronous search state aligned with browser Back/Forward
         * navigation.
         *
         * For now we reload on popstate so the complete server-rendered state,
         * including the left-side filters, is guaranteed to match the URL.
         */
        $(window).on(
            'popstate.locationSearch-' +
            $component.attr('id'),
            function () {
                window.location.reload();
            }
        );
    }

})(jQuery); 